import { Box, Button, TableCell } from "@mui/material";
import Icon from "components/icon/icon";
import AddressInput from "../address-input/address-input";
import { BaseTableRow } from "./BaseTableRow";

export const NoMatchTableRow = ({
  currency,
  aggregationUnit,
  item,
  selectedId,
  setSelectOnMap,
  onRowClick,
  handleMove,
  editItem,
  t
}: any) => {
  const handleMoveDefault = () => handleMove(item.id);
  const handleMoveToComplete = () => handleMove(item.id, "complete");

  return (
    <BaseTableRow
      currency={currency}
      aggregationUnit={aggregationUnit}
      item={item}
      selectedId={selectedId}
      onRowClick={onRowClick}
    >
      <TableCell sx={{ padding: "0 8px" }}>
        <AddressInput
          item={item || {}}
          edit={editItem}
          setSelectOnMap={setSelectOnMap}
        />
      </TableCell>
      <TableCell sx={{ padding: "8px" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            color="success"
            onClick={handleMoveToComplete}
            disabled={!item.latitude || !item.longitude}
          >
            {t("addressEncoding.table.complete")}
          </Button>
          <Box
            className="tooltip tooltip-left"
            data-tip={t("addressEncoding.tip.no_match")}
          >
            <Icon
              icon="delete"
              style={{ color: "#666" }}
              onClick={handleMoveDefault}
            />
          </Box>
        </Box>
      </TableCell>
    </BaseTableRow>
  );
};
